import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG, IAppConfig } from '../../app.config';
import { MessageService } from '../../core/service/message.service';
import { ProgressBarService } from '../../core/service/progress-bar.service';
import { DataService } from '../../core/service/base/data.service';
import { PriceList } from '../model/pricelist';
import { MeterMediaType } from '../model/const/enums';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class PriceListService extends DataService<PriceList> {
  private readonly _default_FilterFields: string[] = ['name', 'meterType'];

  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, PriceList, progressBar, 'imd-pricelist');
  }

  getFilterDefinition(): Observable<{
    name: string;
    meterType: MeterMediaType;
    selectedFields: string[];
    defaultFields: string[];
  }> {
    return this.client
      .get<any>(`${this.endpoint}/filter`)
      .pipe(
        map(res => {
          return {
            name: res.name ? res.name : '',
            meterType: res.meterType,
            selectedFields: Array.isArray(res.selectedFields) ? res.selectedFields : this._default_FilterFields,
            defaultFields: this._default_FilterFields,
          };
        })
      )
      .pipe(
        catchError(error => {
          console.log(error);
          return [];
        })
      );
  }
}
